import axios from 'axios';

interface ServerErrorBody {
  message?: string;
  body?: {
    message?: string;
    data?: { message?: string };
  };
}

/** First candidate that is a non-blank string, or '' when there is none. */
export const firstNonEmpty = (...candidates: unknown[]): string => {
  const found = candidates.find(c => typeof c === 'string' && c.trim() !== '');
  return typeof found === 'string' ? found : '';
};

/**
 * jarvis-api builds its envelope with `createResponse(status, statusText, data)`,
 * so the top-level `message` is the upstream HTTP status text - literally
 * "Bad Request" - while the service's own message sits one level down. Read the
 * inner ones first, or every upstream 4xx reports itself as "Bad Request".
 */
export const getAxiosErrorMessage = (err: unknown): string => {
  if (!axios.isAxiosError<ServerErrorBody>(err)) return '';
  const data = err.response?.data;
  return firstNonEmpty(
    data?.body?.message,
    data?.body?.data?.message,
    data?.message
  );
};
